var map = {
	"./app-store-reviews.svg": 22160,
	"./app-store.svg": 71540,
	"./custom-inboxes.svg": 11077,
	"./discord-black.svg": 339,
	"./discord-white.svg": 281,
	"./etoro-verified.svg": 53063,
	"./fb-black.svg": 17421,
	"./fb-white.svg": 74579,
	"./fm-korea.svg": 73097,
	"./google-play-post-black.svg": 91074,
	"./google-play-post-reviews.svg": 8188,
	"./google-play-post-white.svg": 79944,
	"./google-play-post.svg": 65192,
	"./google-play.svg": 92573,
	"./ig-black.svg": 70117,
	"./ig-white.svg": 80139,
	"./intercom-black.svg": 84012,
	"./intercom-white.svg": 46506,
	"./linkedin-black.svg": 91379,
	"./linkedin-white.svg": 91321,
	"./placeholder-network.svg": 51607,
	"./reviews-forums.svg": 17457,
	"./steam-reviews.svg": 94105,
	"./trustpilot-black.svg": 14189,
	"./trustpilot-reviews.svg": 98659,
	"./trustpilot-white.svg": 88147,
	"./twitter-black.svg": 51238,
	"./twitter-white.svg": 492,
	"./vanilla-black.svg": 52530,
	"./vanilla-white.svg": 29976,
	"./video-small.svg": 44150,
	"./wix-answers-post.svg": 79194,
	"./wix-answers.svg": 87147,
	"./yt-black.svg": 17186,
	"./yt-white.svg": 14568,
	"./zendesk-black.svg": 84591,
	"./zendesk-white.svg": 12613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64336;